import React from 'react';
import { useFormikContext } from 'formik';

import { SearchType } from '../../types';
import { resetSteps, useCigarette } from '../../context';
import { SEARCH_TYPE_NAMES, INITIAL_VALUES_FORMIK } from '../../constants';
import { afterDepartureStep, afterDestinationStep } from '../../utils';
import CloseButton from '../CloseButton';

interface CloseWizardButtonProps {
  searchType: SearchType;
}

export const CloseWizardButton = ({ searchType }: CloseWizardButtonProps) => {
  const {
    state: { steps, isWizard },
    dispatch,
  } = useCigarette();
  const { resetForm } = useFormikContext();
  const hide = !(
    isWizard &&
    ((searchType === SEARCH_TYPE_NAMES.PACKAGE && afterDepartureStep(steps)) ||
      (searchType === SEARCH_TYPE_NAMES.HOTEL && afterDestinationStep(steps)))
  );

  const handleClick = () => {
    dispatch(resetSteps());
    resetForm({ values: INITIAL_VALUES_FORMIK });
  };

  if (hide) return null;

  return <CloseButton onClick={handleClick} />;
};
